module.exports = __webpack_public_path__ + "img/us_active@2x.d60d1c87.png";